// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';
import { FC, ReactNode } from 'react';
import { X } from 'lucide-react';
import './Modal.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  footer?: ReactNode;
}

const Modal: FC<ModalProps> = ({ isOpen, onClose, title, children, size = 'md', footer }) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    full: 'max-w-full md:max-w-3xl lg:max-w-5xl xl:max-w-7xl md:h-auto md:max-h-[95vh] h-full rounded-none md:rounded-lg'
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-75 p-0 md:p-4 backdrop-blur-sm">
      <div className={`bg-white dark:bg-gray-900 rounded-lg shadow-xl transform transition-all w-full ${sizeClasses[size]} mx-auto max-h-[100vh] md:max-h-[95vh] flex flex-col scrollbar-hide`}>
        <div className="flex items-center justify-center p-4 border-b border-gray-200 dark:border-gray-700 sticky top-0 bg-white dark:bg-gray-900 z-10 md:rounded-t-lg flex-shrink-0">
          <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
          <button
            onClick={onClose}
            className="absolute right-4 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            aria-label="Close modal"
          >
            <X size={24} />
          </button>
        </div>
        <div 
          className="p-4 md:p-6 overflow-y-auto flex-grow scrollbar-hide" 
          style={{
            scrollbarWidth: 'none', /* Firefox */
            msOverflowStyle: 'none', /* Internet Explorer 10+ */
          }}
        >
          {children}
        </div>
        {footer && (
          <div className="p-4 border-t border-gray-200 dark:border-gray-700 sticky bottom-0 bg-white dark:bg-gray-900 z-10 md:rounded-b-lg flex-shrink-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
